import { StyleSheet, View, ViewProps } from 'react-native'
import { Workspace, useWorkspaces } from 'zens-store'
import { Badge, Color, Radius, Spacing } from 'zens-storybook'

import { useTranslation } from 'react-i18next'

import { FloorplanView, FloorplanZoomView } from '../floorplan'

const styles = StyleSheet.create({
  container: {
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
    paddingHorizontal: Spacing.M,
    paddingTop: Spacing.M,
    paddingBottom: Spacing.M,
  },
  skeletonMap: {
    backgroundColor: Color.sleepingGrey,
    borderRadius: Radius.S,
    margin: Spacing.S,
  },
  loading: {
    position: 'absolute',
    bottom: Spacing.M,
    right: Spacing.M,
  },
})

export type LabelType = 'name' | 'serialnumber'

interface Props extends ViewProps {
  companyId: number
  floorId: number
  workspaceId?: number
  labels?: LabelType
}

const FloorFloorplan = (props: Props) => {
  const { companyId, floorId, workspaceId, labels, style, ...otherProps } = props

  const workspaces = useWorkspaces({ companyId, filter: { floorId: [floorId] } })
  const { t } = useTranslation()
  const workspaceItems = workspaces.data?.data
  const totalNumberOfWorkspaces = workspaces.data?.data?.length
  function colorForWorkspace(workspace: Workspace) {
    return workspace?.id === workspaceId ? Color.greyBlue : Color.simplyWhite
  }

  function borderColorForWorkspace() {
    return labels ? Color.modifiedGrey : Color.premiumBlack
  }

  function labelForWorkspace(workspace: Workspace) {
    return labels === 'name'
      ? workspace?.name
      : labels === 'serialnumber'
        ? workspace?.product?.serialNumber
        : undefined
  }

  return (
    <>
      <FloorplanZoomView style={[styles.container, style]} testID="FloorFloorplan.FloorplanZoomView" {...otherProps}>
        <FloorplanView
          companyId={companyId}
          floorId={floorId}
          data={workspaceItems}
          itemColor={(item) => colorForWorkspace(item as Workspace)}
          itemBorderColor={borderColorForWorkspace}
          itemLabel={(item) => labelForWorkspace(item as Workspace)}
        />
      </FloorplanZoomView>
      {workspaces.isFetching && (
        <Badge
          title={t('Loading workspaces ({{loaded}} of {{total}})...', {
            loaded: workspaceItems?.length,
            total: totalNumberOfWorkspaces,
          })}
          style={styles.loading}
          status="inactive"
        />
      )}
    </>
  )
}

interface SkeletonProps extends ViewProps {}
const Skeleton = (props: SkeletonProps) => {
  const { style, ...otherProps } = props
  return <View style={[styles.container, styles.skeletonMap, style]} {...otherProps} />
}
FloorFloorplan.Skeleton = Skeleton

export default FloorFloorplan
